import { createFileRoute } from "@tanstack/react-router";
import { ConfidenceCheck } from "@/lib/lazyPages";
import { confidenceCheckFaqJsonLd } from "@/config/seoConfig";
import { seoHead } from "@/lib/seo/head";
import { RelatedResources } from "@/components/seo/RelatedResources";

// All three URLs canonicalise to /confidence-check-for-kids.
const seo = {
  title: "Free Confidence Checker for Kids (8-14)",
  description:
    "A 2-minute scenario-based confidence checker for your child, with a personalised report across 4 dimensions plus a parent playbook.",

  canonical: "/confidence-check-for-kids",
  ogImage: "https://leadxkids.com/og-confidence-check.jpg",
  jsonLd: confidenceCheckFaqJsonLd,
};

export const Route = createFileRoute("/confidence-check-for-kids")({
  head: () => seoHead(seo),
  component: () => (
    <>
      <ConfidenceCheck />
      <RelatedResources
        title="Keep building confidence"
        items={[
          { href: "/topics/confidence", label: "Confidence in children 8-14", note: "What confidence looks like at this age, and where to start." },
          { href: "/blog/how-to-build-confidence-in-child", label: "How to build confidence in your child", note: "Our in-depth parent guide with everyday steps." },
          { href: "/courses/speak-without-freezing", label: "Speak Without Freezing course", note: "A guided course for children who hold back from speaking up." },
        ]}
      />
    </>
  ),
});
